import React, {useEffect, useState} from "react";
import {Badge, Button, Col, Row, Spinner, Stack} from "react-bootstrap";
import {Popover} from "antd";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import Modal from "react-bootstrap/Modal";
import {fetchAdvancedTypesSales, fetchCompanyDetails} from "../../../../_apis/api";
import FavoriteExamsModal from "./Components/favoriteExamsModal";
import MassFetchModal from "./Components/massFetchModal";
import Alert from "react-bootstrap/Alert";
import {getOptionsByData, isEmpty} from "../../../../_helpers/commonFunctions";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";

const PrescriptionSettings = () => {
    const dispatch = useDispatch();
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyHasPrescription = useSelector((state) => state.PRESCRIPTION.companyHasPrescription);
    const [credentials, setCredentials] = useState({
        username: "",
        password: "",
        environment: "production",
    })
    const [doctorUnits, setDoctorUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("");
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(false);

    const [showChangeUnitModal, setShowChangeUnitModal] = useState(false);
    const [toSetUnitId, setToSetUnitId] = useState("");

    const [showFavoriteExams, setShowFavoriteExams] = useState(false);
    const [showMassFetch, setShowMassFetch] = useState(false);

    const documentTypesOptions = [{
        value: "",
        label: "Κενό"
    }, ...getOptionsByData(SETTINGS.settings.advancedTypesSales, "_id", "name")];
    const [defaultProductData, setDefaultProductData] = useState([]);

    const envOptions = [
        {label: "Δοκιμή", value: "test"},
        {label: "Παραγωγικό", value: "production"}
    ]

    useEffect(() => {
        fetchPrescriptionCredentials();
        dispatch(fetchAdvancedTypesSales({company: company.id}));
    }, [])

    useEffect(() => {
        if (!isEmpty(settings.autoSaleDocumentType)) {
            fetchProducts(null, setDefaultProductData);
        }
    }, [settings.autoSaleDocumentType])

    const fetchProducts = (keyword, setData) => {
        const reqData = {
            company: company.id,
        }
        if (!isEmpty(keyword)) reqData.name = keyword;
        if (settings.autoSaleDocumentType) reqData.id = settings.autoSaleDocumentType;
        axios.get(`${process.env.REACT_APP_API_URL2}/sale/product-list-by-advanced-type-id`, {
            params: reqData,
        }).then((res) => {
            if (res.data.data) {
                setData(res.data.data);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchPrescriptionCredentials = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/get-credentials`, {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setCredentials(res.data.credentials);
                if (res.data.doctorUnits) setDoctorUnits(res.data.doctorUnits);
                if (res.data.selectedUnit) setSelectedUnit(res.data.selectedUnit);
                if (res.data.settings) {
                    setSettings({
                        autoSaleDocumentType: res.data.settings?.autoSaleDocumentType || "",
                        autoSaleDocumentTypeName: res.data.settings?.autoSaleDocumentTypeName || "",
                        autoSaleProduct: res.data.settings?.autoSaleProduct || "",
                        autoSaleProductName: res.data.settings?.autoSaleProductName || "",
                        autoSaleReferralProduct: res.data.settings?.autoSaleReferralProduct || "",
                        autoSaleReferralProductName: res.data.settings?.autoSaleReferralProductName || "",
                    });
                }
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση στοιχείων.")
        })
    }

    const savePrescriptionCredentials = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/save-credentials`, {
            company: company.id,
            credentials: credentials,
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής ενεργοποίηση.");
                fetchPrescriptionCredentials();
                dispatch(fetchCompanyDetails(company.id));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleSaveChangeUnit = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/change-unit`, {
            company: company.id,
            unitId: toSetUnitId,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowChangeUnitModal(false);
                toast.success("Επιτυχής αλλαγή μονάδος συνταγογράφησης.");
                fetchPrescriptionCredentials();
                dispatch(fetchCompanyDetails(company.id));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleSaveSettings = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/save-settings`, {
            company: company.id,
            settings: settings,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αποθήκευση ρυθμίσεων.");
                fetchPrescriptionCredentials();
                dispatch(fetchCompanyDetails(company.id));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Row className={`mb-2 ${!companyHasPrescription ? "d-flex justify-content-center" : ""}`}>
                <Col md={companyHasPrescription ? 4 : 6} className={companyHasPrescription ? "border-right" : ""}>
                    {!companyHasPrescription && (
                        <Alert variant={"secondary"}>
                            Παρακαλώ προβείτε σε ενεργοποίηση με τους κωδικούς σας που χρησιμοποιείτε για να συνδεθείτε
                            στο e-prescription.gr έτσι ώστε να ενεργοποιηθεί η συνταγογράφηση.
                        </Alert>
                    )}
                    <div className={"text-muted mb-1"}><i>Στοιχεία e-Prescription</i></div>
                    <Popover placement={"right"} content={
                        <div>
                            Το όνομα χρήστη που χρησιμοποιείτε για να συνδεθείτε στο e-prescription.gr
                        </div>
                    }>
                        <>
                            <Input
                                className={"mb-2"}
                                name={"prescriptionUsername"}
                                label={"Όνομα Χρήστη"}
                                value={credentials.username}
                                autoComplete={"off"}
                                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                            />
                        </>
                    </Popover>

                    <Popover placement={"right"} content={
                        <div>
                            Ο κωδικός που χρησιμοποιείτε για να συνδεθείτε στο e-prescription.gr
                        </div>
                    }>
                        <>
                            <Input
                                className={"mb-2"}
                                name={"prescriptionPassword"}
                                label={"Κωδικός Χρήστη"}
                                type={"password"}
                                value={credentials.password}
                                autoComplete={"off"}
                                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                            />
                        </>
                    </Popover>
                    <Dropdown
                        name={"prescriptionEnvironment"}
                        options={envOptions}
                        label={"Περιβάλλον"}
                        defaultValue={envOptions.find((el) => el.value === credentials.environment)}
                        key={Math.random()}
                        onChange={(e) => setCredentials({...credentials, environment: e.value})}
                    />
                    <div style={{textAlign: "center"}}>
                        <Button onClick={() => savePrescriptionCredentials()} disabled={loading}>
                            Ενεργοποίηση {loading &&
                            <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                        </Button>
                    </div>
                    {companyHasPrescription && (
                        <div className={"mt-2"}>
                            <div className={"text-muted mb-1"}><i>Λοιπές Λειτουργίες</i></div>
                            <Stack gap={1}>
                                <Button size={"sm"} onClick={() => setShowFavoriteExams(true)}>Τροποποίηση / Προβολή
                                    αγαπημένων εξετάσεων</Button>
                                <Button size={"sm"} onClick={() => setShowMassFetch(true)}>Άντληση δεδομένων από
                                    ΗΔΙΚΑ</Button>
                            </Stack>
                        </div>
                    )}
                </Col>
                {companyHasPrescription && (
                    <Col md={8}>
                        {doctorUnits?.length > 0 && (
                            <React.Fragment>
                                <div className={"text-muted mb-1"}><i>Στοιχεία Μονάδων Συνταγογράφησης</i></div>
                                <table className={"simpleClassicTable"}>
                                    <colgroup>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "60%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th>Κωδικός</th>
                                        <th>Στοιχεία μονάδος</th>
                                        <th>Επιλογή μονάδος</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {doctorUnits.map((unit, idx) => (
                                        <tr key={`dUnit-${idx}`}>
                                            <td>{unit.id}</td>
                                            <td>{unit.healthCareUnitDescription} {!isEmpty(unit.description) ? `(${unit.description})` : ""}</td>
                                            <td>{selectedUnit === unit.id ? (
                                                <Badge bg={"success"}>Επιλεγμένο</Badge>
                                            ) : (
                                                <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => {
                                                    setToSetUnitId(unit.id);
                                                    setShowChangeUnitModal(true);
                                                }}>Επιλογή</Badge>
                                            )}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>

                                <Modal show={showChangeUnitModal} onHide={() => setShowChangeUnitModal(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Αλλαγή μονάδος συνταγογράφησης</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>Είσαστε σίγουροι ότι θέλετε να αλλάξετε μονάδα
                                        συνταγογράφησης;</Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="primary" onClick={() => handleSaveChangeUnit()}>
                                            Ναι, αλλαγή
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </React.Fragment>
                        )}
                        <hr/>
                        <div style={{textAlign: "center"}}>
                            <h6>Λοιπές Ρυθμίσεις</h6>
                        </div>
                        <Row>
                            <Col md={6}>
                                <Dropdown
                                    label={"Προεπιλεγμένο παραστατικό κατά την έκδοση"}
                                    key={Math.random()}
                                    defaultValue={documentTypesOptions.find((el) => el.value === settings?.autoSaleDocumentType)}
                                    name="documentType"
                                    options={documentTypesOptions}
                                    onChange={(e) => {
                                        if (e.value !== settings.autoSaleDocumentType) {
                                            setSettings({
                                                ...settings,
                                                autoSaleDocumentType: e.value,
                                                autoSaleDocumentTypeName: e.label,
                                                autoSaleProduct: "",
                                                autoSaleProductName: "",
                                                autoSaleReferralProduct: "",
                                                autoSaleReferralProductName: "",
                                            })
                                        }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <AdvancedCombobox
                                    className="w-100 ac-select-dropdown"
                                    label={"Είδος αποθήκης επίσκεψης"}
                                    defaultValue={settings?.autoSaleProductName || ""}
                                    data={defaultProductData}
                                    onChange={(e) => setSettings({
                                        ...settings,
                                        autoSaleProduct: e.row._id,
                                        autoSaleProductName: e.row.name
                                    })}
                                    excludeColumns={[]}
                                    columns={[
                                        {label: "Κωδικός είδους", name: "code"},
                                        {label: "Όνομα είδους", name: "name"}
                                    ]}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    key={Math.random()}
                                    onChangeSearch={(keyword, setData) => fetchProducts(keyword, setData)}
                                    disabled={isEmpty(settings.autoSaleDocumentType)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <AdvancedCombobox
                                    className="w-100 ac-select-dropdown"
                                    label={"Είδος αποθήκης εκτ. παραπεμπτικών"}
                                    defaultValue={settings?.autoSaleReferralProductName || ""}
                                    data={defaultProductData}
                                    onChange={(e) => setSettings({
                                        ...settings,
                                        autoSaleReferralProduct: e.row._id,
                                        autoSaleReferralProductName: e.row.name
                                    })}
                                    excludeColumns={[]}
                                    columns={[
                                        {label: "Κωδικός είδους", name: "code"},
                                        {label: "Όνομα είδους", name: "name"}
                                    ]}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    key={Math.random()}
                                    onChangeSearch={(keyword, setData) => fetchProducts(keyword, setData)}
                                    disabled={isEmpty(settings.autoSaleDocumentType)}
                                />
                            </Col>
                        </Row>
                        <Row className={"justify-content-end"}>
                            <Col md={12} className={"d-flex justify-content-end"}>
                                <Button size={"sm"} onClick={() => handleSaveSettings()}>Αποθήκευση λοιπών
                                    ρυθμίσεων</Button>
                            </Col>
                        </Row>
                        <FavoriteExamsModal
                            show={showFavoriteExams}
                            setShow={setShowFavoriteExams}
                        />
                        <MassFetchModal
                            show={showMassFetch}
                            setShow={setShowMassFetch}
                        />
                    </Col>
                )}
            </Row>
        </React.Fragment>
    )
}

export default PrescriptionSettings
